<template>
  <!-- ex-list .el -->
  <div class="el">
    <div class="el-search" v-if="listType == 0">
      <div>
        <input
          type="text"
          v-model="searchText"
          @keyup.enter="searchPro"
          :placeholder="searchPlaceholder"
        />
        <span @click="searchPro">Search</span>
      </div>
    </div>
    <div class="el-search" v-if="listType == 1">
      <div class="search-key">
        <input
          type="text"
          v-model="searchText"
          @keyup.enter="searchPro"
          :placeholder="searchPlaceholder"
          style="width: 400px; border-radius: 5px 5px"
        />
      </div>
      <div class="search-number">
        <input
          type="text"
          v-model="boothInfoEx"
          @keyup.enter="searchPro"
          placeholder="Please enter the Booth Number"
          style="width: 400px"
        />
        <span @click="searchPro" class="search-pc">Search</span>
      </div>
      <div class="btn">
        <div @click="searchPro" class="search-mobile btn-s">Search</div>
        <div @click="ResetAll" class="resetAllCss btn-a">Reset/All</div>
        <div @click="popUp = true" class="resetAllCss search-mobile btn-t">Filter</div>
      </div>
    </div>
    <div class="search-pc">
      <Row type="flex" justify="space-between">
        <Col style="width: 260px; background: #fff">
          <div class="ex-exhibitor">
            <div class="ex-title" style="font-size: 16px">Exhibition projects</div>
            <div class="groupList">
              <div class="group" v-for="(item, index) in allExGroup">
                <div
                  class="item"
                  @click="clickShow(item)"
                  :class="item.isShow ? 'exActive' : 'exActiveFalse'"
                >
                  <span class="name"> {{ item.name }}</span>
                  <!-- <i class="icon iconfont icon-xiala"></i> -->
                </div>
                <div class="list-group-item" v-if="item.isShow">
                  <div
                    class="hoverText"
                    :class="item2.isShow ? 'item2TextColor' : ''"
                    style="padding: 0px 10px; margin: 10px 5px"
                    v-for="(item2, index2) in item.children"
                    @click="clickShow2(item2, item)"
                  >
                    <span class="exId"> {{ item2.nameEn }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <filterCommon
            ref="childComponentRef"
            :filterCommonLoading="filterCommonLoading"
            :categoryList="categoryList"
            @changeCategory="changeCategory"
          ></filterCommon>
        </Col>
        <Col style="width: 920px">
          <proItem
            v-if="listType == 0"
            :pageIndex="PageIndex"
            :pageSize="PageSize"
            :proList="proList"
            :proLoading="proLoading"
            :totalCount="Total"
            @getProList="getProList"
            @addProsuccess="addProsuccess"
            @cancelProsuccess="cancelProsuccess"
          ></proItem>
          <exItem
            v-if="listType == 1"
            :exList="exList"
            :pageIndex="exPageIndex"
            :pageSize="exPageSize"
            :exLoading="exLoading"
            :totalCount="exTotal"
            @getExList="getExList"
            @addsuccess="addsuccess"
            @cancelsuccess="cancelsuccess"
          ></exItem>
        </Col>
      </Row>
    </div>
    <div class="search-mobile">
      <proItem
        v-if="listType == 0"
        :pageIndex="PageIndex"
        :pageSize="PageSize"
        :proList="proList"
        :proLoading="proLoading"
        :totalCount="Total"
        @getProList="getProList"
        @addProsuccess="addProsuccess"
        @cancelProsuccess="cancelProsuccess"
      ></proItem>
      <exItem
        v-if="listType == 1"
        :exList="exList"
        :pageIndex="exPageIndex"
        :pageSize="exPageSize"
        :exLoading="exLoading"
        :totalCount="exTotal"
        @getExList="getExList"
        @addsuccess="addsuccess"
        @cancelsuccess="cancelsuccess"
      ></exItem>
    </div>
    <div class="pop-up" v-show="popUp">
      <div class="ex-exhibitor">
        <div class="close">
          <div class="ex-title" style="font-size: 16px">Exhibition projects</div>
          <div class="" @click="popUp = false">
            <i class="icon iconfont icon-guanbi2"></i>
          </div>
        </div>
        <div class="groupList">
          <div class="group" v-for="(item, index) in allExGroup">
            <div class="item"
               @click="clickShow(item)"
                  :class="item.isShow ? 'exActive' : 'exActiveFalse'"
                  >
              <span class="name"> {{ item.name }}</span>
            </div>
            <div class="list-group-item">
              <div
                class="hoverText"
                :class="item2.isShow ? 'item2TextColor' : ''"
                style="padding: 0px 10px; margin: 10px 5px"
                v-for="(item2, index2) in item.children"
                @click="clickShow2(item2, item)"
              >
                <span class="exId"> {{ item2.nameEn }}</span>
              </div>
            </div>
          </div>

          <filterCommon
            ref="childComponentRef"
            :filterCommonLoading="filterCommonLoading"
            :categoryList="categoryList"
            @changeCategory="changeCategory"
          ></filterCommon>
        </div>

        <div class="pop-btn">
          <div @click="ResetAll">Reset/All</div>
          <div @click="popUp = false">Filter</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filterCommon from "@components/En/filter-common/filter-common2.vue";
import exItem from "./components/ex-item.vue";
import proItem from "./components/pro-item.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
//   $(".exId").click(function () {
//         if ($(this).hasClass("exActive")) {
//             $(this).removeClass("exActive");
//         } else {
//             $(this).addClass("exActive");
//         }
//     })
export default {
  name: "ex-list",
  data() {
    return {
      popUp: false,
      searchText: "",
      searchPlaceholder: "Please enter the keyword of products for searching",
      listType: 0, // 0 产品；1 展商
      PageIndex: 1, // 分页
      PageSize: 10, // 默认50个一页
      Total: 0,
      proList: [],
      categoryList: [],
      categoryId: "",
      exList: [],
      allExGroup: [], //所有展会
      exPageIndex: 1,
      exPageSize: 10,
      exTotal: 0,
      filterCommonLoading: false,
      proLoading: false,
      exLoading: false,
      boothInfoEx: "",
      exIdClick: "00000000-0000-0000-0000-000000000000",
      BoothInfoValue: "",

      groupIdSelect: null,
    };
  },
  components: { filterCommon, exItem, proItem },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      searchType: "exhibitor/getSearchType",
      searchContent: "exhibitor/getSearchContent",
      caId: "exhibitor/getCaId",
      user: "getUser",
    }),
    condition() {
      let info = this.searchText;
      if (this.searchContent && this.searchType == 0) {
        info = this.searchContent;
      }
      //分页获取条件
      return {
        body: {
          PageSize: this.PageSize,
          PageIndex: this.PageIndex,
          ExhibitionId: this.exIdClick,
          ProductName: info,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 0, // 0是and 1是或
              Predicates: [
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "category",
                    Value: `%${this.categoryId}%`,
                  },
                },
              ],
            },
          },
        },
        topic: -1,
        apply: 0,
      };
    },
    exCondition() {
      let info = this.searchText;
      if (this.searchContent && this.searchType == 1) {
        info = this.searchContent;
      }

       

      let objData = {
        PageSize: this.exPageSize,
        PageIndex: this.exPageIndex,
        // ExhibitionId: this.exIdClick,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 1, // 0是and 1是或
            Predicates: [],
          },
        },
      };
      if (this.groupIdSelect) {
        objData.groupId = this.groupIdSelect;
      }
      if (this.categoryId) {
        objData.actionTypeList = this.categoryId;
      }

      //   if (this.categoryId) {
      //     objData.Wheres.wheres.Predicates.push({
      //       type: 1,
      //       wheres: {
      //         WhereOperator: 6,
      //         Label: "Categories",
      //         Value: `%${this.categoryId}%`,
      //       },
      //     });
      //   }
      if (info) {
        objData.Wheres.wheres.Predicates.push(
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "Name",
              Value: "%" + info + "%",
            },
          },

          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "NameEn",
              Value: "%" + info + "%",
            },
          }
        );
      }

      if (this.boothInfoEx) {
        objData.Wheres.wheres.Predicates.push({
          type: 1,
          wheres: {
            WhereOperator: 6,
            Label: "BoothInfo",
            Value: "%" + this.boothInfoEx + "%",
          },
        });
      }
      return objData;
      return;

      //  objData.Wheres.wheres.Predicates.push()

      //分页获取条件
      if (this.categoryId) {
        return {
          PageSize: this.exPageSize,
          PageIndex: this.exPageIndex,
          ExhibitionId: this.exhibitionId,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 0, // 0是或 1是且
              Predicates: [
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "Name",
                    Value: "%" + info + "%",
                  },
                },
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "BoothInfo",
                    Value: "%" + this.boothInfoEx + "%",
                  },
                },
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "Categories",
                    Value: `%${this.categoryId}%`,
                  },
                },
              ],
            },
          },
        };
      } else {
        return {
          PageSize: this.exPageSize,
          PageIndex: this.exPageIndex,
          ExhibitionId: this.exhibitionId,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 1, // 0是或 1是且
              Predicates: [
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "Name",
                    Value: "%" + info + "%",
                  },
                },

                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "NameEn",
                    Value: "%" + info + "%",
                  },
                },
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "BoothInfo",
                    Value: "%" + this.boothInfoEx + "%",
                  },
                },
              ],
            },
          },
        };
      }
    },
  },
  watch: {
    listType(val, oldVal) {
      if (val == 0) {
        this.searchPlaceholder = "Please enter the keyword of products for searching";
        this.searchText = "";
        this.getPro();
      }
      if (val == 1) {
        this.searchPlaceholder = "Please enter the keyword of exhibitors for searching";
        this.searchText = "";
        this.getEx();
      }
    },
    searchContent(val, oldVal) {
      if (this.searchType == 0) {
        this.listType = 0;
        this.getPro();
      }
      if (this.searchType == 1) {
        this.listType = 1;
        this.getEx();
      }
    },
    // caId(val,oldVal) {
    //   // console.log(val);
    //   this.categoryId = val;
    //   this.setCaId("");
    //   if (this.searchType == 0) {
    //     this.listType = 0;
    //     this.getPro();
    //   }
    //   if (this.searchType == 1) {
    //     this.listType = 1;
    //     this.getEx();
    //   }
    // }
    $route(to, from) {
      if (this.$route.query.id) {
        this.categoryId = this.$route.query.id;
      } else {
        this.categoryId = "";
      }
      this.getPro();
      this.getCategory();
      this.getEx();
    },
    user(val, oldVal) {
      if (this.listType == 0) {
        this.getPro();
      }
      if (this.listType == 1) {
        this.getEx();
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.categoryId = this.$route.query.id;
    }
    this.getPro();
    this.getCategory();
    this.getEx();
    this.getAllListEx();

    this.listType = 1;
  },
  methods: {
    ...mapMutations({
      setSearchContent: "exhibitor/setSearchContent",
      setSearchType: "exhibitor/setSearchType",
      setCaId: "exhibitor/setCaId",
    }),
    ...mapActions({
      getProduct: "exhibitor/getProduct",
      getProductCategory: "exhibitor/getProductCategory",
      getActionType: "exhibitor/getActionType",
      getRanking: "exhibitor/getRanking",
      getAllExList: "exhibitor/getAllExList",
      applyCompanyHall: "exhibitor/applyCompanyHall",
      getAllExhibitionsApplyCompany: "exhibitor/getAllExhibitionsApplyCompany",
    }),

    async getAllListEx() {
      let opt = {
        pageSize: 100,
        pageIndex: 1,
        agentId: "cd4e8cef-c6f7-4e72-9132-93161b9e8c43",
      };
      let idsToDelete = [
        // "46F6F63D-E30A-4386-B190-0E4C4BA06827",
        "3CED0899-CFD3-4735-83E3-F4FC2241F028",
        // "71B57CF1-E617-4912-9EA9-B17EAB06E375",
        "034CF342-A72A-49BC-B3FB-5239E105E4CB",
        // "949E3761-B303-4597-8BEC-3F206913A86D",
        "8DE82036-9105-4426-BB2D-237FC5BC195A",
      ];
      let exAllList = [];
      let list = await this.getAllExList(opt);

      if (list.items.length > 0) {
        exAllList = list.items.filter(
          (obj) => !idsToDelete.includes(obj.id.toUpperCase())
        );

        const groupList = [
          {
            name: "CMEF",
            groupId: 1,
            children: [],
            isShow: false,
            exId: "",
          },
          {
            name: "ICMD",
            groupId: 5,
            children: [],
            isShow: false,
            exId: "",
          },
          {
            name: "CRS",
            groupId: 4,
            children: [],
            isShow: false,
            exId: "",
          },
        ];

        //   查询项目
        //      let res = await this.getAllExhibitionsApplyCompany();
        //   if (res.data && res.data.length > 0) {
        //     groupList.forEach((item) => {
        //       res.data.forEach((item1) => {
        //         if (item.name == item1.name) {
        //           item.exId = item1.value;
        //         }
        //       });
        //     });
        //   }

        // 查询项目下所有展馆
        //      for (let k of groupList) {
        //     k.isShow = false;
        //     let resHall = await this.applyCompanyHall(k.exId);
        //     k.resHall = resHall.hallList.split(",");
        //     k.resHall.forEach((c) => {
        //       k.children.push({
        //         id: c,
        //         nameEn: c,
        //         isShow: false,
        //       });
        //     });
        //   }

        console.log(groupList, "groupList");
        this.allExGroup = groupList;
      }
    },
    clickShow(item) {
      //   item.isShow = !item.isShow;

      this.groupIdSelect = null;
      if (item.isShow) {
        item.isShow = false;
      } else {
        this.allExGroup.forEach((item) => {
          item.isShow = false;
        });
        item.isShow = true;
      }

      // 循环allExGroup数组   如果 isShow为true   this.groupIdSelect=item.groupId;  否则  this.groupIdSelect=null;
      const selectedItem = this.allExGroup.find((item) => item.isShow);
      this.groupIdSelect = selectedItem ? selectedItem.groupId : null;

      this.exPageSize = 10;
      this.exPageIndex = 1;
      this.getEx();
    },
    clickShow2(item2, item) {
      if (this.exIdClick == item2.id) {
        item2.isShow = false;
        this.exIdClick = "00000000-0000-0000-0000-000000000000";
      } else {
        this.allExGroup.forEach((item) => {
          item.children.forEach((item1) => {
            item1.isShow = false;
          });
        });

        item2.isShow = !item2.isShow;
        // this.exIdClick = item2.id;
        this.exIdClick = item.exId;
      }

      this.BoothInfoValue = item2.nameEn;
      this.getExList();
    },
    ResetAll() {
      this.boothInfoEx = "";
      this.BoothInfo = "";
      this.BoothInfoValue = "";
      this.searchText = "";
      this.exIdClick = "00000000-0000-0000-0000-000000000000";
      this.categoryId = null;

      this.allExGroup.forEach((item) => {
        item.isShow = false;
        item.children.forEach((item1) => {
          item1.isShow = false;
        });
      });
      this.$refs.childComponentRef.childMethod();

      this.actionTypeList = [];
      this.searchPro();
      this.popUp = false;
    },

    searchPro() {
      this.setSearchContent("");
      if (this.listType == 0) {
        this.getPro();
      }
      if (this.listType == 1) {
        this.getEx();
      }
    },
    changeCategory(e) {
      this.categoryId = e;
      if (this.listType == 0) {
        this.getPro();
      }
      if (this.listType == 1) {
        this.getEx();
      }
    },
    getProList(e) {
      if (e) {
        this.PageSize = e.pageSize;
        this.PageIndex = e.pageIndex;
      }
      this.getPro();
    },
    getExList(e) {
      if (e) {
        this.exPageSize = e.pageSize;
        this.exPageIndex = e.pageIndex;
      }
      this.getEx();
    },
    async getPro() {
      this.proLoading = true;
      this.listType = 0;
      let result = await this.getProduct(this.condition);
      if (result && result.items) {
        result.items.map((c) => {
          if (c.banner.search(/^\[/) !== -1) {
            c.banner = JSON.parse(c.banner);
          } else {
            c.banner = [c.banner];
          }
        });
        this.proLoading = false;
        this.proList = result.items;
        this.PageIndex = result.pageIndex;
        this.PageSize = result.pageSize;
        this.Total = result.totalCount;
      }
      console.log("proList：", this.proList);
    },
    async getCategory() {
      this.filterCommonLoading = true;
      let list = await this.getActionType();
      if (list) {
        this.categoryList = list;
        this.filterCommonLoading = false;
      }
    },
    async getEx() {
      this.exLoading = true;
      console.log(this.exCondition, "this.exConditionthis.exCondition");
      //   this.exCondition.BoothInfo=this.BoothInfoValue;

     

      let list = await this.getRanking(this.exCondition);
      if (list) {
        if (list && list.items) {
          list.items.map((c) => {
            if (c.listProduct) {
              c.listProduct.map((d) => {
                if (d.banner.search(/^\[/) !== -1) {
                  d.banner = JSON.parse(d.banner);
                } else {
                  d.banner = [d.banner];
                }
              });
            }
            if (c.boothInfo) {
              c.boothInfo = JSON.parse(c.boothInfo);
            }
          });
        }
        this.exLoading = false;
        this.exList = list.items;
        this.exPageIndex = list.pageIndex;
        this.exPageSize = list.pageSize;
        this.exTotal = list.totalCount;
        console.log("exList：", this.exList);
      }
    },
    addsuccess(val) {
      this.exList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = true;
        }
      });
    },
    cancelsuccess(val) {
      this.exList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = false;
        }
      });
    },
    addProsuccess(val) {
      this.proList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = true;
        }
      });
    },
    cancelProsuccess(val) {
      this.proList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = false;
        }
      });
    },
  },

  destroyed() {
    this.setSearchContent("");
    this.setSearchType(0);
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 799px) {
  .search-pc {
    display: block !important;
  }
  .search-mobile {
    display: none !important;
  }
  .el {
    margin-top: 20px;
    .el-search {
      width: 1200px;
      background-color: #fff;
      height: 168px;
      margin: -20px 0 20px;
      padding-top: 60px;
      display: flex;
      div {
        //   width: 900px;
        margin: 0 auto;
        height: 48px;
        input {
          width: 816px;
          height: 48px;
          border: solid 1px #024c8b;
          border-radius: 5px 0 0 5px;
          outline: none;
          padding-left: 10px;
          font-size: 16px;
        }
        ::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #ccc;
          font-size: 16px;
        }
        ::-moz-placeholder {
          /* Firefox 19+ */
          color: #ccc;
          font-size: 16px;
        }
        :-ms-input-placeholder {
          /* IE 10+ */
          color: #ccc;
          font-size: 16px;
        }
        :-moz-placeholder {
          /* Firefox 18- */
          color: #ccc;
          font-size: 16px;
        }
        span {
          display: inline-block;
          width: 84px;
          height: 48px;
          background-color: #024c8b;
          text-align: center;
          line-height: 48px;
          color: #fff;
          font-size: 16px;
          border-radius: 0 5px 5px 0;
          cursor: pointer;
        }
      }
    }
    .el-list-title {
      width: 100%;
      height: 48px;
      border-bottom: 2px solid #024c8b;
      span {
        display: inline-block;
        width: 160px;
        height: 46px;
        background-color: #fff;
        text-align: center;
        line-height: 46px;
        font-size: 16px;
        color: #333;
        margin-right: 10px;
        cursor: pointer;
      }
      .active {
        background-color: #024c8b;
        color: #fff;
      }
    }
  }
  .ex-exhibitor {
    padding: 20px;
  }
  .exActive {
    background-color: #024c8b;
    color: #fff;
  }

  .exActiveFalse {
    background-color: rgb(245, 245, 245);
  }

  .hoverText:hover {
    color: #024c8b;
    background-color: #edf2f7;
  }
  .item2TextColor {
    color: #024c8b;
    background-color: #edf2f7;
  }
  .ex-swiper-container {
    text-align: center;
  }

  #show-table .layui-col-md6 {
    width: 50%;
    float: left;
  }

  .groupList .group {
    border: 1px solid #f5f5f5;
    color: #333;
    border-radius: 5px;
    margin-top: 15px;
  }

  .groupList .group .item {
    font-size: 18px;
    padding: 12px 12px;

    border-radius: 5px;
    cursor: pointer;
  }

  .groupList .group .item > .iconfont {
    float: right;
    color: #999;
  }

  .groupList .group .item:hover {
    background-color: #024c8b;
    color: #fff;
  }

  .groupList .group .item:hover > .iconfont {
    color: #fff;
  }

  .list-group-item {
    //   padding: 10px 15px;
    border: none;
    cursor: pointer;
    // height: 0;
    transition: height 2s;
    -webkit-transition: height 2s;
    // overflow: hidden;
  }

  .groupList .group.hover .item {
    border-radius: 5px 5px 0 0;
    background-color: #024c8b;
    color: #fff;
  }

  .groupList .group.hover .list-group-item {
    height: auto;
    padding: 10px 15px;
  }

  .groupList .group.hover .iconfont {
    color: #fff;
    transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    margin-top: 3px;
  }

  // .item {
  //   background-color: #fff;
  // }

  .item_top {
    color: #333;
    display: flex;
  }

  .line {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.16rem;
  }

  .name {
    font-weight: 400;
  }

  .job {
    font-size: 12px;
    color: #666;
  }

  .phone {
    font-size: 14px;
    color: #333;
  }

  .info2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .rn-type {
    display: inline-block;
    font-size: 14px;
    padding: 0px 5px;
    margin-bottom: 12px;
    border-width: 1px;
    border-style: solid;
  }

  .el-carousel__container {
    position: relative;
    height: 130px;
  }

  .resetAllCss {
    width: 84px;
    //   height: 48px;
    line-height: 50px;
    border-radius: 5px;
    color: #fff;
    background-color: #024c8b;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .search-key {
    display: flex;
    justify-content: center;
  }
  .search-number {
    display: flex;
  }
}
@media (max-width: 799px) {

      .exActive {
    background-color: #024c8b;
    color: #fff;
  }

  .exActiveFalse {
    color: #333333;
    // background-color: rgb(245, 245, 245);
  }

  input::placeholder {
    color: #999 !important;
  }
  .gContent {
    width: 100% !important;
  }
  .search-pc {
    display: none !important;
  }
  .search-mobile {
    display: block !important;
  }
  .el {
    width: 100%;
  }
  .el-search {
    padding: calc(80vw / 7.5) 15px;
    flex-wrap: wrap;
    // width: 100%;
    .search-key {
      width: 100%;
    }
    .search-number {
      width: 100%;
    }
    input {
      width: 100% !important;
      height: calc(78vw / 7.5);
      background-color: #ffffff;
      border-radius: calc(10vw / 7.5);
      border: solid 1px #024c8b;
      padding-left: 10px;
      margin-bottom: calc(30vw / 7.5);
    }
  }
  .btn {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .btn-s {
    width: calc(300vw / 7.5);
    height: calc(78vw / 7.5);
    background-color: #024c8b;
    border-radius: calc(10vw / 7.5);
    font-family: PingFang-SC-Regular;
    text-align: center;
    font-size: calc(26vw / 7.5);
    font-weight: normal;
    font-stretch: normal;
    line-height: calc(78vw / 7.5);
    letter-spacing: 0px;
    color: #ffffff;
  }
  .resetAllCss {
    width: calc(165vw / 7.5);
    height: calc(78vw / 7.5);
    // background-color: #024c8b;
    border: 1px solid #024c8b;
    border-radius: calc(10vw / 7.5);
    font-family: PingFang-SC-Regular;
    text-align: center;
    font-size: calc(26vw / 7.5);
    font-weight: normal;
    font-stretch: normal;
    line-height: calc(76vw / 7.5);
    letter-spacing: 0px;
    color: #024c8b;
  }
  .pop-up {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 9999;

    .ex-exhibitor {
      height: calc(1090vw / 7.5);
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #fff;
      border-radius: 40px 40px 0 0;
      padding: 0 15px;
      .close {
        display: flex;
        justify-content: space-between;
        height: calc(100vw / 7.5);
        line-height: calc(100vw / 7.5);
        .ex-title {
          font-family: PingFang-SC;
          font-size: calc(32vw / 7.5);
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
          font-weight: bold;
        }
        i {
          color: #333333;
          font-size: calc(48vw / 7.5);
        }
      }
      .groupList {
        width: 100%;
        height: calc(890vw / 7.5);
        overflow-y: auto;
        .item {
          font-family: PingFang-SC-Bold;
          font-size: calc(26vw / 7.5);
          font-weight: bold;
          font-stretch: normal;
          line-height: calc(20vw / 7.5);
          letter-spacing: 0px;
        //   color: #333333;
          padding: calc(20vw / 7.5) 0 calc(26vw / 7.5);
          border-radius: 5px;
        }
        .list-group-item {
          display: flex;
          flex-wrap: wrap;
          .hoverText {
            padding: 0 calc(40vw / 7.5) !important;
            margin: 0 calc(7.5vw / 7.5) calc(20vw / 7.5) !important;
            // height: calc(58vw/7.5);
            line-height: calc(58vw / 7.5);
            background-color: #f5f5f5;
            border-radius: 5px;
            font-family: PingFang-SC-Regular;
            font-size: calc(26vw / 7.5);
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
          }
          .item2TextColor {
            background-color: #024c8b;
            color: #fff;
          }
        }
      }
      .pop-btn {
        position: absolute;
        display: flex;
        justify-content: space-between;
        // padding-top: 20px;
        height: calc(100vw / 7.5);
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 5px 15px 0;
        div {
          width: calc(335vw / 7.5);
          height: calc(80vw / 7.5);
          line-height: calc(80vw / 7.5);
          border-radius: calc(16vw / 7.5);
          font-family: PingFang-SC-Medium;
          font-size: calc(30vw / 7.5);
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          text-align: center;
        }
      }
      .pop-btn div:first-child {
        background-color: rgba($color: #024c8b, $alpha: 0.1);
        color: #024c8b;
      }
      .pop-btn div:last-child {
        background-color: #024c8b;
        color: #ffffff;
      }
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
